export const FILTER_PRICE_VARIABLES = {
  DEFAULT_MIN: 0,
  DEFAULT_MAX: 10000,
}
